const menu = {
  'menu.brexit-guide': 'Download your free Brexit Guide',
  'menu.teflCourses': 'Cursos de TEFL',
  'menu.trinityCerttesol': 'Curso Trinity CertTESOL',
  'menu.onlineTrinity': 'Curso Desarrollo Docente',
  'menu.developingTeacher': 'Curso Docente Avanzado',
  'menu.developingTeacher&Spanish': 'Catalan y Curso Docente Avanzado',
  'menu.teachingYoungLearners': 'Teaching Young Learners',
  'menu.classesDeIngles': 'Clases de Inglés',
  'menu.allCourses': 'Todos los cursos',

  'menu.locations': 'UBICACIONES',
  'menu.barcelona': 'Barcelona',
  'menu.seville': 'Sevilla',

  'menu.dates&fees': 'Fechas y Tarifas',
  'menu.dates': 'Fechas y tarifas',
  'menu.paymentPlan': 'Plan de pagos',
  'menu.specialOffers': 'Ofertas especiales',
  'menu.work&Visas': 'TRABAJO y Visas',
  'menu.carrerService': 'Servicio de Orientación Profesional',
  'menu.studentsVisas': 'Visa de estudiante',
  'menu.accommodation': 'Alojamiento',
  'menu.resources': 'Recursos',

  'menu.about': 'NOSOTROS',
  'menu.teflIberiaStory': 'La historia de TEFL Iberia',
  'menu.whatIsTefl': '¿Qué es TEFL?',
  'menu.accreditations': 'Acreditación',
  'menu.meetTheTeam': 'Conoce al equipo',
  'menu.teflIberiaGraduates': 'Graduados de TEFL Iberia',
  'menu.workWithUs': 'Trabaja con nosotros',
  'menu.entryRequirements': 'Requisitos de admisión',
  'menu.faqs': 'Preguntas frecuentes',
  'menu.blog': 'Blog',
  'menu.contact': 'Contacto',
  'menu.applyNow': 'Inscríbete Ahora',
  'menu.signUpNow': 'Inscríbete ahora',
};

export default menu;
